/**
 * Service Dependencies
 */
import http from 'axios'

/**
 * Configure HTTP Adapter
 */
http.defaults.baseURL = process.env.API_URL

/**
 * Set default authorization token for every request
 *
 * @param  {String} token
 * @return {Void}
 */
export const setAuthorizationHeader = (token) => {
    http.defaults.headers.common = {
        'Authorization': `Bearer ${window.localStorage.getItem('id_token')}`
    }
}

/**
 * Remove default authorization token from requests
 *
 * @return {Void}
 */
export const removeAuthorizationHeader = () => {
    http.defaults.headers.common = {}
}

/**
 * GET Request
 *
 * @param  {String} url
 * @param  {Object} config
 * @return {Promise}
 */
export const get = (url, config) => {
    return http.get(url || '', config || {})
}

/**
 * DELETE Request
 *
 * @param  {String} url
 * @param  {Object} config
 * @return {Promise}
 */
export const del = (url, config) => {
    return http.delete(url || '', config || {})
}

/**
 * HEAD Request
 *
 * @param  {String} url
 * @param  {Object} config
 * @return {Promise}
 */
export const head = (url, config) => {
    return http.head(url || '', config || {})
}

/**
 * POST Request
 *
 * @param  {String} url
 * @param  {Object} data
 * @param  {Object} config
 * @return {Promise}
 */
export const post = (url, data, config) => {
    return http.post(url || '', data || {}, config || {})
}

/**
 * PUT Request
 *
 * @param  {String} url
 * @param  {Object} data
 * @param  {Object} config
 * @return {Promise}
 */
export const put = (url, data, config) => {
    return http.put(url || '', data || {}, config || {})
}

/**
 * PATCH Request
 *
 * @param  {String} url
 * @param  {Object} data
 * @param  {Object} config
 * @return {Promise}
 */
export const patch = (url, data, config) => {
    return http.patch(url || '', data || {}, config || {})
}

/**
 * HTTP Service Declaration
 */
export default {
    get,
    put,
    del,
    post,
    head,
    patch
}



// WEBPACK FOOTER //
// ./src/services/HttpService.js